module.exports = __webpack_public_path__ + "static/media/pro-manPhoto04.0e9d91d9.jpg";